import { 
    REGISTER_LICENSE_CODE_CLEAR_ERROR,
    REGISTER_LICENSE_CODE_ERROR,
    REGISTER_LICENSE_CODE_RESET,
    REGISTER_LICENSE_CODE_VALIDATE_SUCCESS 
} from "../constants";

export const clearError = () => ({
    type: REGISTER_LICENSE_CODE_CLEAR_ERROR,
    payload: {
        errors: [],
    },
});

export const loadValidationSuccess = (data) => ({
    type: REGISTER_LICENSE_CODE_VALIDATE_SUCCESS,
    payload: {
        ...data,
    },
});

export const loadError = (error) => ({
    type: REGISTER_LICENSE_CODE_ERROR,
    payload: {
        error,
    }
});

export const resetModalState = () => ({
    type: REGISTER_LICENSE_CODE_RESET,
});